import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ensureNfAbMasterCookie } from './utils/ensureNfAbMasterCookie'

const shouldApplyNewDashboardCookieOverride = location => new URLSearchParams(location?.search || '').get('tf') === '3.0'

export const NewDashboardCookieWatcher = () => {
  const history = useHistory()

  useEffect(() => {
    if (shouldApplyNewDashboardCookieOverride(history.location)) {
      ensureNfAbMasterCookie('nf_ab_new_dashboard_reload_done')
    }
  }, [])

  useEffect(
    () =>
      history.listen(location => {
        if (shouldApplyNewDashboardCookieOverride(location)) {
          ensureNfAbMasterCookie('nf_ab_new_dashboard_reload_done')
        }
      }),
    [history],
  )

  return null
}
